import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  mediaZoomRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const imageTextSquaredRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const media = selector('[data-motion-media]')[0]
  const title = selector('[data-motion-title]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]
  const button = selector('[data-motion-button]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let mediaAnimation: SharedAnimation
  if (media) {
    mediaAnimation = mediaZoomRevealAnimation(media)
    timeline.add(mediaAnimation.timeline, 0)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = linesRevealAnimation(paragraph, reverse)
    timeline.add(paragraphAnimation.timeline, 0.3)
  }

  let buttonAnimation: SharedAnimation
  if (button) {
    buttonAnimation = fadeRevealAnimation(button)
    timeline.add(buttonAnimation.timeline, 0.6)
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    paragraphAnimation?.revert()
    mediaAnimation?.revert()
    buttonAnimation?.revert()
  }
}
